// extracted by mini-css-extract-plugin
export var mainWrapper = "buttonsSection-module--mainWrapper--f4004";